import './App.css';
import './styles/Calendar.css'
import './styles/Clock.css'
import './styles/DateTimePicker.css'
import { QueryClient, QueryClientProvider } from 'react-query';
import { ApolloProvider } from '@apollo/client';
import LiffProvider from './lib/components/common/liffProvider';
import client from "@/graphql/client";
import LiffStub from './lib/components/stub/liffStub';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Index from './Home';
import NewReservation from './pages/reservation/createReservation/[productionId]/[stageId]';
import ReservationMenu from './pages/reservation/createReservation/[productionId]';
import AdminMenu from './pages/admin/AdminMenu';
import Confirm from './pages/admin/Confirm';
import { Helmet } from "react-helmet"
import CancelManagement from './pages/admin/CancelManagement';
import { Amplify } from 'aws-amplify';

import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { cognitoConfig } from './lib/ts/constants';
import AdminCancel from './pages/admin/AdminCancel';

Amplify.configure({
  Auth: {
    Cognito: cognitoConfig
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const Component = () => {
  return (
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={<Index />}
          />
          <Route
            path="/reservation/createReservation/:productionId/:stageId"
            element={<NewReservation />}
          />
          <Route
            path="/reservation/createReservation/:productionId"
            element={<ReservationMenu />}
          />
          <Route 
            path="/admin/AdminMenu"
            element={<AdminMenu />}
          />
          <Route 
            path="/admin/confirm"
            element={<Confirm />}
          />
          <Route 
            path="/admin/CancelManagement"
            element={<CancelManagement />}
          />
          <Route 
            path="/admin/Cancel"
            element={<AdminCancel />}
          />
        </Routes>
      </BrowserRouter>
  )
}

export default function App() {
  const env = process.env.REACT_APP_ENV;
  return env === "pro" ? (
    <>
      <QueryClientProvider client={queryClient}>
        <ApolloProvider client={client}>
            <Helmet>
              <meta property='og:url' content='https://d22y651v09er3g.cloudfront.net' />
              <meta property='og:title' content='1-Ahead reservation' />
              <meta property='og:description' content='マジック公演を予約しよう' />
              <meta property='og:image' content='../public/logo.jpg' />
            </Helmet>
            <Component />
        </ApolloProvider>
      </QueryClientProvider>
    </>
  ) : (
    <>
      <QueryClientProvider client={queryClient}>
        <ApolloProvider client={client}>
          <Helmet>
            <meta property='og:url' content='https://d22y651v09er3g.cloudfront.net' />
            <meta property='og:title' content='1-Ahead reservation' />
            <meta property='og:description' content='マジック公演を予約しよう' />
            <meta property='og:image' content='../public/logo.jpg' />
          </Helmet>
          <LiffStub>
              <Component />
          </LiffStub>
        </ApolloProvider>
      </QueryClientProvider>
    </>
  );
}

